import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Layout from "./components/Layout";
import Index from "./pages/Index";

const Projects = lazy(() => import("./pages/Projects"));
const ProjectDetail = lazy(() => import("./pages/ProjectDetail"));
const WoodCatalog = lazy(() => import("./pages/WoodCatalog"));
const Contact = lazy(() => import("./pages/Contact"));
const Gallery = lazy(() => import("./pages/Gallery"));
const OAuthConsent = lazy(() => import("./pages/OAuthConsent"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe"));
const Terms = lazy(() => import("./pages/legal/Terms"));
const Privacy = lazy(() => import("./pages/legal/Privacy"));
const CookiesPage = lazy(() => import("./pages/legal/Cookies"));
const LegalNotice = lazy(() => import("./pages/legal/LegalNotice"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Index />} />
              <Route path="/projekty" element={<Projects />} />
              <Route path="/projekty/:id" element={<ProjectDetail />} />
              <Route path="/archivni-drevo" element={<WoodCatalog />} />
              <Route path="/galerie" element={<Gallery />} />
              <Route path="/kontakt" element={<Contact />} />
              <Route path="/obchodni-podminky" element={<Terms />} />
              <Route path="/zasady-ochrany-osobnich-udaju" element={<Privacy />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="/pravni-upozorneni" element={<LegalNotice />} />
            </Route>
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
